/**
 * DCC专员跟进模拟数据
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock开关
let mockSwich = mock ? '' : '_'

// 跟进概况 - DCC跟进
Mock.mock(/sale_report\/all_clues/, 'get' + mockSwich, {
  'code': 0,
  'data': [
    {
      'arrived': 11,
      'booked': 11,
      'contacted': 11,
      'dcc': 'DCC-A',
      'dealed': 11,
      'defeated': 11,
      'not_contacted': 11
    }, {
      'arrived': 11,
      'booked': 11,
      'contacted': 11,
      'dcc': 'DCC-B',
      'dealed': 11,
      'defeated': 11,
      'not_contacted': 11
    }, {
      'arrived': 11,
      'booked': 11,
      'contacted': 11,
      'dcc': 'DCC-C',
      'dealed': 11,
      'defeated': 11,
      'not_contacted': 11
    }, {
      'arrived': 11,
      'booked': 11,
      'contacted': 11,
      'dcc': '合计',
      'dealed': 11,
      'defeated': 11,
      'not_contacted': 11
    }
  ],
  'message': 'ok'
})

// 待跟进 - DCC跟进
Mock.mock(/sale_report\/dcc_clue_follow_up/, 'get' + mockSwich, {
  'code': 0,
  'data': [
    {
      'all_follow_up': 456,
      'all_to_arrive': 456,
      'dcc': '张三',
      'today_follow_up': 456,
      'today_to_arrive': 456
    }, {
      'all_follow_up': 456,
      'all_to_arrive': 456,
      'dcc': '张三',
      'today_follow_up': 456,
      'today_to_arrive': 456
    }, {
      'all_follow_up': 456,
      'all_to_arrive': 456,
      'dcc': '合计',
      'today_follow_up': 456,
      'today_to_arrive': 456
    }
  ],
  'message': 'ok'
})

Mock.mock(/sale_report\/dccs/, 'get' + mockSwich, {
  'code': 0,
  'data': [
    {
      'id': 123456,
      'name': '张三1'
    }, {
      'id': 123457,
      'name': '张三2'
    }, {
      'id': 123458,
      'name': '张三3'
    }, {
      'id': 123459,
      'name': '张三4'
    }, {
      'id': 123460,
      'name': '张三5'
    }
  ],
  'message': 'ok'
})
// DCC专员营销漏斗分析 - DCC跟进
Mock.mock(/sale_report\/dcc_funnel_statistical_analysis/, 'get' + mockSwich, {
  'code': 0,
  'data': {
    'arrived': 123,
    'arrived_rate': 0.11,
    'arrived_to_deal_rate': 0.11,
    'clue': 123,
    'deal': 123,
    'deal_rate': 0.11
  },
  'message': 'ok'
})
